import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "flex flex-col pb-3" }
const _hoisted_3 = { class: "flex flex-col pb-3" }
const _hoisted_4 = { class: "flex justify-end gap-3 pt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_NextButton = _resolveComponent("NextButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Field, { field_name: "Policy" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("textarea", {
              class: "p-3 border-next-gray-md-dark border-2 w-full",
              rows: "6",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.infoPolicyModel) = $event))
            }, null, 512), [
              [_vModelText, _ctx.infoPolicyModel]
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Field, { field_name: "Data offerta" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dataOffertaModel) = $event)),
              type: "date",
              class: "flex-grow p-7px bg-next-gray-md-dark hover:bg-white"
            }, null, 512), [
              [_vModelText, _ctx.dataOffertaModel]
            ])
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_Field, { field_name: "Termini di pagamento" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("textarea", {
            class: "p-3 border-next-gray-md-dark border-2 w-full",
            rows: "6",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.terminiPagamentoModel) = $event))
          }, null, 512), [
            [_vModelText, _ctx.terminiPagamentoModel]
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_NextButton, {
        variant: "outline-secondary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('chiudi'))),
        class: "w-44 py-2 px-4"
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createTextVNode(" Chiudi ")
        ])),
        _: 1
      }),
      _createVNode(_component_NextButton, {
        variant: "primary",
        disabled: _ctx.$attrs.waiting,
        onClick: _ctx.save,
        class: "w-44 py-2 px-4"
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [
          _createTextVNode(" Salva ")
        ])),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ]))
}